import * as XLSX from 'xlsx';

/**
 * Generate and download Excel template for department creation
 * Includes an instructions sheet and a data sheet with example rows
 */
export function downloadDepartmentTemplate(): void {
  const workbook = XLSX.utils.book_new();

  // Create Instructions Sheet
  const instructions = [
    { Instruction: 'Bulk Department Upload Template' },
    { Instruction: '' },
    { Instruction: 'Instructions:' },
    {
      Instruction: '1. Fill in the "Departments" sheet with your department data'
    },
    {
      Instruction: '2. Required fields: Name and Abbreviation (marked with * in header)'
    },
    {
      Instruction: '3. Parent Abbreviation: Enter the abbreviation of the parent department'
    },
    {
      Instruction:
        '   - Can reference departments already in your system OR departments in this upload'
    },
    { Instruction: '   - Leave blank for root departments (no parent)' },
    { Instruction: '   - Avoid circular references (A → B → A)' },
    {
      Instruction: '4. Manager Email: Enter the email address of the department manager'
    },
    { Instruction: '5. Upload the file and review validation results' },
    { Instruction: '6. Fix any errors before submitting' },
    { Instruction: '' },
    { Instruction: 'Example:' },
    {
      Instruction: 'Row 1: Corporate (CORP) - no parent (root department)'
    },
    {
      Instruction: 'Row 2: Sales (SALES) - parent: CORP (references row 1)'
    },
    {
      Instruction: 'Row 3: Sales North America (SALES-NA) - parent: SALES (references row 2)'
    }
  ];

  const instructionSheet = XLSX.utils.json_to_sheet(instructions);
  instructionSheet['!cols'] = [{ wch: 80 }];
  XLSX.utils.book_append_sheet(workbook, instructionSheet, 'Instructions');

  // Create Departments Sheet with sample data
  const template = [
    {
      'Name*': 'Corporate',
      'Abbreviation*': 'CORP',
      Description: 'Corporate headquarters',
      'Parent Abbreviation': '',
      'Manager Email': 'ceo@example.com'
    },
    {
      'Name*': 'Sales Department',
      'Abbreviation*': 'SALES',
      Description: 'Sales and business development',
      'Parent Abbreviation': 'CORP',
      'Manager Email': 'sales.manager@example.com'
    },
    {
      'Name*': 'Sales North America',
      'Abbreviation*': 'SALES-NA',
      Description: 'Sales operations in North America',
      'Parent Abbreviation': 'SALES',
      'Manager Email': 'sales.na@example.com'
    },
    {
      'Name*': '',
      'Abbreviation*': '',
      Description: '',
      'Parent Abbreviation': '',
      'Manager Email': ''
    }
  ];

  const dataSheet = XLSX.utils.json_to_sheet(template);

  // Set column widths
  dataSheet['!cols'] = [
    { wch: 30 }, // Name
    { wch: 20 }, // Abbreviation
    { wch: 40 }, // Description
    { wch: 25 }, // Parent Abbreviation
    { wch: 30 } // Manager Email
  ];

  XLSX.utils.book_append_sheet(workbook, dataSheet, 'Departments');

  // Generate file and trigger download
  XLSX.writeFile(workbook, 'department_template.xlsx');
}
